import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import {
  getTransactionsHistoryAdminServices,
  changeOrderTypeHistoryServices,
  getLiveTransactionAdminService,
} from "../../../services/userServices";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { changeOrderTypeAdminServices } from "./../../../services/userServices";

export const transactionAdminContext = createContext({
  //* Live Orders Start
  counter: "",
  setCounter: () => {},
  getLiveOrders: [],
  setGetLiveOrders: () => {},
  data: [],
  setData: () => {},
  hesabiApiStatus: null,
  setHesabiApiStatus: () => {},
  handleGetLiveOrders: () => {},
  handleChangeOrderType: () => {},
  //* History Orders Start
  getOrdersHistoryAdmin: [],
  setGetOrdersHistoryAdmin: () => {},
  startDate: "",
  setStartDate: () => {},
  productType: "",
  setProductType: () => {},
  handleGetOrderHistoryAdmin: () => {},
  handleSubmitAdmin: () => {},
  handleChangeOrderTypeHistory: () => {},
});

const TransactionAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [getLiveOrders, setGetLiveOrders] = useState([]);
  const [data, setData] = useState([]);
  const [counter, setCounter] = useState(0);
  const [hesabiApiStatus, setHesabiApiStatus] = useState(null);

  const [getOrdersHistoryAdmin, setGetOrdersHistoryAdmin] = useState([]);
  const [startDate, setStartDate] = useState([]);
  const [productType, setProductType] = useState("");

  //! Live Order Component
  //* Handle Get Live Orders
  const handleGetLiveOrders = async () => {
    try {
      const { status, data } = await getLiveTransactionAdminService();
      if (status === 200) {
        setGetLiveOrders(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    }
  };

  //* Change Order Type Live Orders
  const handleChangeOrderType = async (id, tType) => {
    const objData = { id, tType };

    try {
      dispatch(setLoadingTrueAction());
      const apiResult = await changeOrderTypeAdminServices(objData);
      const { status, response } = apiResult;

      setHesabiApiStatus(response?.data?.hesabi_api_sent);

      if (status === 200) {
        handleGetLiveOrders();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //! History Orders Component
  //* Handle Get History Orders
  const handleGetOrderHistoryAdmin = async () => {
    const objData = {
      Date: startDate,
      productType: productType,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getTransactionsHistoryAdminServices(
        objData
      );
      if (status === 200) {
        setGetOrdersHistoryAdmin(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  //* Handle Fetch Filter Of History Orders
  const handleSubmitAdmin = (e) => {
    e.preventDefault();
    handleGetOrderHistoryAdmin();
  };

  //* Change Order Type History Order
  const handleChangeOrderTypeHistory = async (id, tType) => {
    const objData = { id, tType };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await changeOrderTypeHistoryServices(objData);
      if (status === 200) {
        handleGetOrderHistoryAdmin();
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toast.error(response.data.message);
        }
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <transactionAdminContext.Provider
      value={{
        //* Live Orders Start
        counter,
        setCounter,
        getLiveOrders,
        setGetLiveOrders,
        data,
        setData,
        hesabiApiStatus,
        setHesabiApiStatus,
        handleGetLiveOrders,
        handleChangeOrderType,
        //* History Orders Start
        getOrdersHistoryAdmin,
        setGetOrdersHistoryAdmin,
        startDate,
        setStartDate,
        productType,
        setProductType,
        handleGetOrderHistoryAdmin,
        handleSubmitAdmin,
        handleChangeOrderTypeHistory,
      }}
    >
      {children}
    </transactionAdminContext.Provider>
  );
};

export default TransactionAdminContext;
